import styled from '@emotion/styled';
import { useFeatureFlag } from 'hooks';
import groupBy from 'lodash/groupBy';
import { type BrandListIntegrationProps, IntegrationType } from 'types/integrations';
import LoadingSpinner from 'ui/LoadingSpinner';
import BrandListIntegrationStatus from './BrandListIntegrationStatus';

const BrandListIntegrationsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const BrandListIntegrations = ({
  integrations,
  loading,
  brandId,
  isAdAccountActive,
  isTiktokAdAccountActive
}: Exclude<BrandListIntegrationProps, 'type'>) => {
  const { tiktokIntegration } = useFeatureFlag();

  if (loading) return <LoadingSpinner />;

  const groupedIntegrations = groupBy(integrations, 'type');

  return (
    <BrandListIntegrationsWrapper>
      <BrandListIntegrationStatus
        brandId={brandId}
        isAdAccountActive={isAdAccountActive}
        integrations={groupedIntegrations}
        type={IntegrationType.Facebook}
      />
      <BrandListIntegrationStatus
        brandId={brandId}
        integrations={groupedIntegrations}
        type={IntegrationType.Shopify}
      />
      {!!tiktokIntegration && (
        <BrandListIntegrationStatus
          brandId={brandId}
          isAdAccountActive={isTiktokAdAccountActive}
          integrations={groupedIntegrations}
          type={IntegrationType.TikTok}
        />
      )}
    </BrandListIntegrationsWrapper>
  );
};

export default BrandListIntegrations;
